export const DEFAULT_MAX_HEIGHT = '280px';
